import { useState } from "react"
import { useEffectUpdate } from "./useEffectUpdate"
import DOMPurify from 'dompurify';

export const useForm = (initialState, cb = () => { }) => {

    const [fields, setFields] = useState(initialState)

    useEffectUpdate(() => {
        cb(fields)
    }, [fields])

    const handleChange = ({ target }) => {
        const field = target.name
        const value = target.type === 'number' ? (+target.value || '') : DOMPurify.sanitize(target.value)
        setFields(prevFields => ({ ...prevFields, [field]: value }))
    }

    return [fields, handleChange, setFields]
}